import axiosInstance from 'api/axios';

interface voiceApiResponse {
  name: string;
  id: string;
  url: string;
  voice: string;
  gender: 'Female' | 'Male';
}

export const voiceSelectionService = {
  getVoices: async (): Promise<voiceApiResponse[]> => {
    const response = await axiosInstance.public.get(
      `/api/v1/text-to-speech/get-all-voices`
    );

    return response.data.data;
  },
};
